<app-smash-back-btn (goBack)="back()"></app-smash-back-btn>

<div class="premium-card">
	<div class="premium-card-header">
		<div class="premium-card-header-title">
			<h1>
				{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TITLE_SECTION' | translate }}
			</h1>
		</div>
		<div *ngIf="transfer" class="premium-card-header-actions">
			<div class="icon icon-refresh" (click)="refreshDetails()">
				<i class="icon-smash_remote"></i>
			</div>
			<button class="btn-new dark" *ngIf="transfer.status === 'Uploaded'" (click)="deleteTransfer()">
				{{ 'PREMIUM_TRANSFER_SENT_UNACTIVATE_TRANSFER' | translate }}
			</button>
		</div>
	</div>
	<ng-container *ngIf="transferLoading; else transferNotLoading">
		<div class="premium-card-loading-container">
			<div class="loading-spinner-grey"></div>
		</div>
	</ng-container>
	<ng-template #transferNotLoading>
		<div class="premium-card-center">
			<table class="informations">
				<tr>
					<th>{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_CREATION_DATE' | translate }}</th>
					<td>{{transfer.created | dateLocale: 'll LT'}}</td>
				</tr>
				<tr *ngIf="transfer?.title">
					<th>{{ 'PREMIUM_TRANSFER_TABLE_LABEL_SUBJECT' | translate }}</th>
					<td>{{ transfer.title }}</td>
				</tr>
				<tr *ngIf="transfer?.delivery?.type">
					<th>{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_DELIVERY_TYPE' | translate }}</th>
					<td>{{type[transfer.delivery.type] | translate}}</td>
				</tr>
				<tr>
					<th>{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_FILE_NUMBER' | translate }}</th>
					<td>{{transfer.filesNumber}}</td>
				</tr>
				<tr>
					<th>{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_SIZE' | translate }}</th>
					<td>{{transfer.size | bytes:2}}</td>
				</tr>
				<ng-container *ngIf="!isCreating">
					<tr>
						<th>{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_LINK' | translate }}</th>
						<td>
							<ng-container *ngIf="transfer?.transferUrl; else noCustomUrl">
								<a class="link-blue" href="{{transfer.transferUrl}}"
									target="_blank">{{transfer.transferUrl}}</a>
							</ng-container>
							<ng-template #noCustomUrl>
								<a class="link-blue" href="https://fromsmash.com/{{transfer.transferUrl}}"
									target="_blank">https://fromsmash.com/{{transfer.id}}</a>
							</ng-template>
						</td>
					</tr>
				</ng-container>
				<tr *ngIf="isCreating || transfer?.availabilityEndDate">
					<th>{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_STATUS' | translate }}</th>
					<td>
						{{status[transfer.status] | translate}}
					</td>
				</tr>
				<tr>
					<th>{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_AVAILIBILITY_DURATION' | translate }}</th>
					<ng-container *ngIf="isCreating; else transferCreated">
						<td>
							{{ 'DAYS' | translate: { count: availabilityDurationInDays } }}
						</td>
					</ng-container>
					<ng-template #transferCreated>
						<ng-container *ngIf="transfer && transferExpired; else transferNotExpired">
							<td class="expiration-text">
								{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_AVAILIBILITY_DURATION_HAS_EXPIRED' | translate }}
								{{transfer.availabilityEndDate | countdown}}
							</td>
						</ng-container>
						<ng-template #transferNotExpired>
							<ng-container *ngIf="transfer && transferDeleted; else transferNotDeleted">
								<td class="expiration-text">
									{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_AVAILIBILITY_DURATION_DELETED' | translate }}
									{{transfer.deleted | countdown}}
								</td>
							</ng-container>
							<ng-template #transferNotDeleted>
								<td>
									{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_AVAILIBILITY_DURATION_ALMOST' | translate }}
									{{transfer.availabilityEndDate | countdown}}
								</td>
							</ng-template>
						</ng-template>
					</ng-template>
				</tr>
				<tr *ngIf="transfer?.delivery?.sender?.email">
					<th>{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_SENDER_EMAIL' | translate }}</th>
					<td><span>{{transfer.delivery.sender.email}}</span></td>
				</tr>
				<tr *ngIf="transfer?.delivery?.sender?.name">
					<th>{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_SENDER_NAME' | translate }}</th>
					<td><span>{{transfer.delivery.sender.name}}</span></td>
				</tr>
				<tr *ngIf="transfer?.delivery?.type === 'Email' && !!transfer.description">
					<th>{{ 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_MESSAGE' | translate }}</th>
					<td><span>{{transfer.description}}</span></td>
				</tr>
			</table>
		</div>
	</ng-template>
</div>

<div class="premium-card" *ngIf="(transferEventsGroupedByEmail$ | async)?.length">
	<div class="premium-card-header">
		<div class="premium-card-header-title">
			<h1>
				{{ 'PREMIUM_TRANSFER_SENT_DETAILS_RECEIVERS_LIST_TITLE_SECTION' | translate }}
			</h1>
		</div>
		<div class="premium-card-header-actions">
			<app-smash-input type="text" borderStyle="full"
				placeholder="{{ 'PREMIUM_TRANSFER_SENT_DETAILS_RECEIVERS_SEARCH_PLACEHOLDER' | translate }}"
				[(ngModel)]="searchReceiver" name="searchReceiver">
			</app-smash-input>
		</div>
	</div>
	<ng-container *ngIf="transferLoading; else receiversNotLoading">
		<div class="premium-card-loading-container">
			<div class="loading-spinner-grey"></div>
		</div>
	</ng-container>
	<ng-template #receiversNotLoading>
		<div class="premium-card-center">
			<ng-container *ngIf="(transferEventsGroupedByEmail$ |async); else noTransferReceivers">
				<app-smash-data-table
					[data]="(transferEventsGroupedByEmail$ |async)" [searchValue]="searchReceiver"
					[columns]='columnsEnabledReceivers' rowClickable='true'
					(rowClicked)='openModalUserTransferActivity($event.email)' enableMoreOptions='true'
					[paginationEnabled]="true">
					<ng-template #optionsList let-item>
						<li (click)="openModalUserTransferActivity(item.email)">
							{{ 'PREMIUM_TRANSFER_SENT_DETAILS_RECEIVERS_MORE_DETAILS' | translate }}
						</li>
					</ng-template>
				</app-smash-data-table>
			</ng-container>
			<ng-template #noTransferReceivers>
				<div class="premium-card-center-no-content">
					<span>
						{{ 'PREMIUM_TRANSFER_SENT_DETAILS_RECEIVERS_NO_RECEIVERS' | translate }}
					</span>
				</div>
			</ng-template>
		</div>
	</ng-template>
</div>

<div class="premium-card">
	<div class="premium-card-header">
		<div class="premium-card-header-title">
			<h1>
				<th>{{ 'PREMIUM_TRANSFER_SENT_DETAILS_FILES_LIST_TITLE_SECTION' | translate }}</th>
			</h1>
		</div>
		<div class="premium-card-header-actions">
			<app-smash-input type="text" borderStyle="full"
				placeholder="{{ 'PREMIUM_TRANSFER_SENT_DETAILS_FILES_SEARCH_PLACEHOLDER' | translate }}"
				[(ngModel)]="searchFiles" name="searchFiles">
			</app-smash-input>
		</div>
	</div>
	<ng-container *ngIf="filesLoading; else transferFilesNotLoading">
		<div class="premium-card-loading-container">
			<div class="loading-spinner-grey"></div>
		</div>
	</ng-container>
	<ng-template #transferFilesNotLoading>
		<div class="premium-card-center">
			<ng-container *ngIf="files && files.length; else noTransferFiles">
				<app-smash-data-table [data]="files" [searchValue]="searchFiles"
					[columns]='columnsEnabledFiles' [paginationEnabled]="true">
				</app-smash-data-table>
			</ng-container>
			<ng-template #noTransferFiles>
				<div class="premium-card-center-no-content">
					<span>
						{{ 'PREMIUM_TRANSFER_SENT_DETAILS_FILES_NO_FILES' | translate }}
					</span>
				</div>
			</ng-template>
		</div>
	</ng-template>
</div>
